<template>
  <div class="d-flex justify-center align-center">
    <template v-if="name==='Mild'">
      <svg
        :style="`width: ${parseInt(size)}px; height: ${parseInt(size)}px;`"
        viewBox="0 0 60 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_2880_23431)">
          <circle
            cx="29.9998"
            cy="28"
            r="19.0476"
            fill="#FFB21E"
          />
          <circle
            cx="29.9998"
            cy="28"
            r="19.5238"
            stroke="white"
            stroke-width="0.952381"
          />
        </g>
        <circle
          cx="30.3125"
          cy="16.4375"
          r="11.5625"
          fill="url(#paint0_radial_2880_23431)"
        />
        <g
          style="mix-blend-mode:multiply"
          filter="url(#filter1_f_2880_23431)"
        >
          <path
            d="M33.4375 42.375C36.2188 42.375 38.9376 41.5502 41.2502 40.005C43.5628 38.4598 45.3652 36.2636 46.4296 33.694C47.4939 31.1244 47.7724 28.2969 47.2298 25.569C46.6872 22.8412 45.3479 20.3355 43.3812 18.3688L41.1535 20.5965C42.6795 22.1226 43.7188 24.0669 44.1398 26.1837C44.5609 28.3004 44.3448 30.4944 43.5189 32.4883C42.693 34.4823 41.2944 36.1865 39.4999 37.3855C37.7054 38.5845 35.5957 39.2245 33.4375 39.2245L33.4375 42.375Z"
            fill="#ED9569"
          />
        </g>
        <g filter="url(#filter2_f_2880_23431)">
          <path
            d="M30.4687 12.6875C26.8875 12.6875 23.4172 13.9301 20.65 16.2033C17.8827 18.4765 15.9899 21.6394 15.2944 25.1525C14.599 28.6655 15.1441 32.3111 16.8367 35.4671C18.5292 38.6231 21.2644 41.0941 24.5755 42.4584L25.3664 40.5392C22.4995 39.3579 20.1314 37.2185 18.666 34.486C17.2005 31.7535 16.7286 28.5972 17.3307 25.5556C17.9328 22.5139 19.5716 19.7754 21.9676 17.8073C24.3635 15.8391 27.3681 14.7633 30.4687 14.7633L30.4687 12.6875Z"
            fill="url(#paint1_linear_2880_23431)"
          />
        </g>
        <g filter="url(#filter3_d_2880_23431)">
          <circle
            cx="29.9998"
            cy="28"
            r="19.5238"
            stroke="white"
            stroke-width="0.952381"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_2880_23431"
            x="0"
            y="0.5"
            width="60"
            height="60"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2.5" />
            <feGaussianBlur stdDeviation="5" />
            <feComposite
              in2="hardAlpha"
              operator="out"
            />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 1 0 0 0 0 0.823529 0 0 0 0 0.498039 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2880_23431"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2880_23431"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_f_2880_23431"
            x="23.4375"
            y="8.3689"
            width="34.0625"
            height="44.0061"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="5"
              result="effect1_foregroundBlur_2880_23431"
            />
          </filter>
          <filter
            id="filter2_f_2880_23431"
            x="11.2498"
            y="8.93731"
            width="22.9691"
            height="37.2714"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="1.8751"
              result="effect1_foregroundBlur_2880_23431"
            />
          </filter>
          <filter
            id="filter3_d_2880_23431"
            x="8.09524"
            y="7.04762"
            width="43.8095"
            height="43.8095"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.952381" />
            <feGaussianBlur stdDeviation="0.952381" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.431373 0 0 0 0 0.556863 0 0 0 0 0.87451 0 0 0 0.32 0"
            />
            <feBlend
              mode="multiply"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2880_23431"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2880_23431"
              result="shape"
            />
          </filter>
          <radialGradient
            id="paint0_radial_2880_23431"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(30.3125 16.4375) rotate(90) scale(11.5625)"
          >
            <stop stop-color="#FFD27F" />
            <stop
              offset="1"
              stop-color="#FFD27F"
              stop-opacity="0"
            />
          </radialGradient>
          <linearGradient
            id="paint1_linear_2880_23431"
            x1="30.4687"
            y1="12.6875"
            x2="30.4688"
            y2="43.625"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop
              offset="1"
              stop-color="white"
              stop-opacity="0"
            />
          </linearGradient>
        </defs>
      </svg>
    </template>

    <template v-else-if="name==='Severe'">
      <svg
        :style="`width: ${parseInt(size)-6}px; height: auto;`"
        viewBox="0 0 60 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_2880_23442)">
          <circle
            cx="29.9998"
            cy="28"
            r="19.0476"
            fill="#ED9569"
          />
          <circle
            cx="29.9998"
            cy="28"
            r="19.5238"
            stroke="white"
            stroke-width="0.952381"
          />
        </g>
        <ellipse
          cx="27.5"
          cy="15.5"
          rx="13.5"
          ry="14"
          fill="url(#paint0_radial_2880_23442)"
        />
        <g
          style="mix-blend-mode:multiply"
          filter="url(#filter1_f_2880_23442)"
        >
          <path
            d="M33.4375 42.375C36.2188 42.375 38.9376 41.5502 41.2502 40.005C43.5628 38.4598 45.3652 36.2636 46.4296 33.694C47.4939 31.1244 47.7724 28.2969 47.2298 25.569C46.6872 22.8412 45.3479 20.3355 43.3812 18.3688L41.1535 20.5965C42.6795 22.1226 43.7188 24.0669 44.1398 26.1837C44.5609 28.3004 44.3448 30.4944 43.5189 32.4883C42.693 34.4823 41.2944 36.1865 39.4999 37.3855C37.7054 38.5845 35.5957 39.2245 33.4375 39.2245L33.4375 42.375Z"
            fill="#EA804B"
          />
        </g>
        <g filter="url(#filter2_f_2880_23442)">
          <path
            d="M30.4687 12.6875C26.8875 12.6875 23.4172 13.9301 20.65 16.2033C17.8827 18.4765 15.9899 21.6394 15.2944 25.1525C14.599 28.6655 15.1441 32.3111 16.8367 35.4671C18.5292 38.6231 21.2644 41.0941 24.5755 42.4584L25.3664 40.5392C22.4995 39.3579 20.1314 37.2185 18.666 34.486C17.2005 31.7535 16.7286 28.5972 17.3307 25.5556C17.9328 22.5139 19.5716 19.7754 21.9676 17.8073C24.3635 15.8391 27.3681 14.7633 30.4687 14.7633L30.4687 12.6875Z"
            fill="url(#paint1_linear_2880_23442)"
          />
        </g>
        <g filter="url(#filter3_d_2880_23442)">
          <circle
            cx="29.9998"
            cy="28"
            r="19.5238"
            stroke="white"
            stroke-width="0.952381"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_2880_23442"
            x="0"
            y="0.5"
            width="60"
            height="60"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2.5" />
            <feGaussianBlur stdDeviation="5" />
            <feComposite
              in2="hardAlpha"
              operator="out"
            />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.956863 0 0 0 0 0.74902 0 0 0 0 0.647059 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2880_23442"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2880_23442"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_f_2880_23442"
            x="23.4375"
            y="8.3689"
            width="34.0625"
            height="44.0061"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="5"
              result="effect1_foregroundBlur_2880_23442"
            />
          </filter>
          <filter
            id="filter2_f_2880_23442"
            x="11.2498"
            y="8.93731"
            width="22.9691"
            height="37.2714"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="1.8751"
              result="effect1_foregroundBlur_2880_23442"
            />
          </filter>
          <filter
            id="filter3_d_2880_23442"
            x="8.09524"
            y="7.04762"
            width="43.8095"
            height="43.8095"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.952381" />
            <feGaussianBlur stdDeviation="0.952381" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.431373 0 0 0 0 0.556863 0 0 0 0 0.87451 0 0 0 0.32 0"
            />
            <feBlend
              mode="multiply"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2880_23442"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2880_23442"
              result="shape"
            />
          </filter>
          <radialGradient
            id="paint0_radial_2880_23442"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(27.5 15.5) rotate(90) scale(14 13.5)"
          >
            <stop stop-color="#F8D5C3" />
            <stop
              offset="1"
              stop-color="#F8D5C3"
              stop-opacity="0"
            />
          </radialGradient>
          <linearGradient
            id="paint1_linear_2880_23442"
            x1="30.4687"
            y1="12.6875"
            x2="30.4688"
            y2="43.625"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop
              offset="1"
              stop-color="white"
              stop-opacity="0"
            />
          </linearGradient>
        </defs>
      </svg>
    </template>

    <template v-else-if="name==='Panic'">
      <svg
        :style="`width: ${parseInt(size)-6}px; height: ${parseInt(size)-6}px;`"
        viewBox="0 0 60 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_2880_23453)">
          <circle
            cx="29.9998"
            cy="28"
            r="19.0476"
            fill="#F08888"
          />
          <circle
            cx="29.9998"
            cy="28"
            r="19.5238"
            stroke="white"
            stroke-width="0.952381"
          />
        </g>
        <circle
          cx="27"
          cy="18.5"
          r="10"
          fill="url(#paint0_radial_2880_23453)"
        />
        <g
          style="mix-blend-mode:multiply"
          filter="url(#filter1_f_2880_23453)"
        >
          <path
            d="M29.5 45.5C32.9612 45.5 36.3446 44.4736 39.2225 42.5507C42.1003 40.6278 44.3434 37.8947 45.6679 34.697C46.9924 31.4993 47.339 27.9806 46.6637 24.5859C45.9885 21.1913 44.3218 18.073 41.8744 15.6256L39.1021 18.3979C41.0012 20.297 42.2945 22.7166 42.8185 25.3508C43.3424 27.9849 43.0735 30.7153 42.0457 33.1966C41.0179 35.6779 39.2774 37.7987 37.0443 39.2909C34.8112 40.783 32.1857 41.5794 29.5 41.5794L29.5 45.5Z"
            fill="#E42525"
          />
        </g>
        <g filter="url(#filter2_f_2880_23453)">
          <path
            d="M30.4687 12.6875C26.8875 12.6875 23.4172 13.9301 20.65 16.2033C17.8827 18.4765 15.9899 21.6394 15.2944 25.1525C14.599 28.6655 15.1441 32.3111 16.8367 35.4671C18.5292 38.6231 21.2644 41.0941 24.5755 42.4584L25.3664 40.5392C22.4995 39.3579 20.1314 37.2185 18.666 34.486C17.2005 31.7535 16.7286 28.5972 17.3307 25.5556C17.9328 22.5139 19.5716 19.7754 21.9676 17.8073C24.3635 15.8391 27.3681 14.7633 30.4687 14.7633L30.4687 12.6875Z"
            fill="url(#paint1_linear_2880_23453)"
          />
        </g>
        <g filter="url(#filter3_d_2880_23453)">
          <circle
            cx="29.9998"
            cy="28"
            r="19.5238"
            stroke="white"
            stroke-width="0.952381"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_2880_23453"
            x="0"
            y="0.5"
            width="60"
            height="60"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2.5" />
            <feGaussianBlur stdDeviation="5" />
            <feComposite
              in2="hardAlpha"
              operator="out"
            />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.956863 0 0 0 0 0.65098 0 0 0 0 0.65098 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2880_23453"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2880_23453"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_f_2880_23453"
            x="19.5"
            y="5.62573"
            width="37.5"
            height="49.8743"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="5"
              result="effect1_foregroundBlur_2880_23453"
            />
          </filter>
          <filter
            id="filter2_f_2880_23453"
            x="11.2498"
            y="8.93731"
            width="22.9691"
            height="37.2714"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="1.8751"
              result="effect1_foregroundBlur_2880_23453"
            />
          </filter>
          <filter
            id="filter3_d_2880_23453"
            x="8.09524"
            y="7.04762"
            width="43.8095"
            height="43.8095"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood
              flood-opacity="0"
              result="BackgroundImageFix"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="0.952381" />
            <feGaussianBlur stdDeviation="0.952381" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.431373 0 0 0 0 0.556863 0 0 0 0 0.87451 0 0 0 0.32 0"
            />
            <feBlend
              mode="multiply"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2880_23453"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2880_23453"
              result="shape"
            />
          </filter>
          <radialGradient
            id="paint0_radial_2880_23453"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(27 18.5) rotate(90) scale(10)"
          >
            <stop
              offset="0.475962"
              stop-color="#F4A6A6"
            />
            <stop
              offset="1"
              stop-color="#F4A6A6"
              stop-opacity="0"
            />
          </radialGradient>
          <linearGradient
            id="paint1_linear_2880_23453"
            x1="30.4687"
            y1="12.6875"
            x2="30.4688"
            y2="43.625"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="white" />
            <stop
              offset="1"
              stop-color="white"
              stop-opacity="0"
            />
          </linearGradient>
        </defs>
      </svg>
    </template>
  </div>
</template>

  <script>
export default {
  name : 'CrisisScenarioIcon',
  props: {
    name: {
      type   : String,
      default: ''
    },
    color: {
      type   : String,
      default: '#ffffff'
    },
    size: {
      type   : [String, Number],
      default: 24
    }
  }
}
  </script>

  <style scoped>

  </style>
